import { IPageableResponse, IParkingModel, IResponse } from '@aggregator/core';
import { Injectable } from '@angular/core';
import { BaseService } from '@shared/core';
import { Observable } from 'rxjs';

@Injectable()
export class ParkingService {
  apiUrl = 'parkings';

  constructor(private service: BaseService) {}

  getAll(filter?: unknown): Observable<IResponse<IPageableResponse<IParkingModel>>> {
    return this.service.get(this.apiUrl, filter);
  }

  getById(id: string): Observable<IResponse<IParkingModel>> {
    return this.service.get<IResponse<IParkingModel>>(this.apiUrl + '/' + id, { id });
  }

  create(data: unknown): Observable<IResponse<IParkingModel>> {
    return this.service.post(this.apiUrl, data);
  }

  upload(formData: FormData): Observable<IResponse<unknown>> {
    return this.service.post<IResponse<unknown>>(this.apiUrl + '/import/csv', formData);
  }

  update(id: string, data: unknown): Observable<IResponse<IParkingModel>> {
    return this.service.put(this.apiUrl + '/' + id, data);
  }

  delete(id: string): Observable<IResponse<void>> {
    return this.service.delete(this.apiUrl + '/' + id);
  }
}
